/**
 * The comparison band's column track, shared by its header row and its rows.
 *
 * One exported object rather than the same `gridTemplateColumns` typed into
 * two components, because the two have to agree at every breakpoint or the
 * headings sit over the wrong cells — and that is a bug nobody sees in review
 * and everybody sees on the page. The header row and `ServiceCompareRow` are
 * the only two callers by construction.
 *
 * Four columns from `md`, a single column below it. There is no sensible
 * two-column middle state: the outcome sentence is the widest cell and it is
 * unreadable in half a phone, so the table stops being a table and becomes
 * the stack of self-describing blocks the row component documents.
 */
export const compareGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    md: 'minmax(0, 1.1fr) minmax(0, 1.6fr) minmax(0, 0.9fr) minmax(0, 0.8fr)',
  },
  gap: { xs: 3, md: 5 },
  alignItems: { xs: 'start', md: 'center' },
} as const;
